import type { Nullish } from '@iheartjane/types';
import { setCookie } from '@iheartjane/utils';

import type { AgeGateType } from '@jane/bloom/types/schemas/bloom/ageGate';
import type { BloomMenuTheme } from '@jane/bloom/types/schemas/roots/bloom/menuTheme';
import { durations } from '@jane/bloom/utils/durations';

export function getAgeGateCookieName(
  theme: BloomMenuTheme,
  type: AgeGateType,
  cookiePrefix: Nullish<string>
): string {
  return `${cookiePrefix ?? ''}${theme.bloom?.age_gate?.[type]?.cookie_name || '__jane_bloom_age_gate_default'}`;
}

export function confirmAge(
  cookieName: string,
  expirySeconds?: Nullish<number>
) {
  const expiry = expirySeconds ?? durations.ONE_WEEK;
  return setCookie(cookieName, 'true', expiry > 0 ? expiry : undefined);
}
